export default {
  '测试记录列表':'测试记录列表',
  '视频不存在':'视频不存在',
  '测试记录':'测试记录',
  '此记录暂无报告':'此记录暂无报告',
}